exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page[data-v-5cc1975f]{width:100%}.column[data-v-5cc1975f]{display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);

// exports
